import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { TransactionListByClient } from 'src/app/core/Models/interfaces/responseData';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { PrescriptionService } from '../../prescription.service';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CommonList } from 'src/app/core/Models/interfaces/commonList';

@Component({
    selector: 'app-prescription-list',
    templateUrl: './prescription-list.component.html',
    styleUrls: ['./prescription-list.component.css']
})
export class PrescriptionListComponent implements OnInit {
    @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
    showPrescriptionDetails: boolean = false;
    transactionListByClient: TransactionListByClient[] = [];
    transactionListByPayer: any[] = [];
    prescriptionFilterForm!: FormGroup
    fetchingInProgress: boolean = false;
    userType = USER_TYPE.payer;
    isLoader = false;
    exportVar = 0;
    public subTypes = SUB_TYPE
    public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;



    totalCount!: number;
    page_no: number = 1;
    page_limit: number = 10;
    batchId: any;
    requestBatchId: any;
    public showNavigation: boolean = false;
    user?: UserDetails;
    sortParams: any;
    columnSort: any = {
        requestId: {
            sortType: 'ascending',
        },
        senderId: {
            sortType: 'ascending',
        },
        receiverId: {
            sortType: 'ascending',
        },
        transactionDate: {
            sortType: 'ascending',
        },
        payerId: {
            sortType: 'ascending',
        },
        memberId: {
            sortType: 'ascending',
        },
        eHealthId: {
            sortType: 'ascending',
        },
        documentID: {
            sortType: 'ascending',
        },
        visitedOn: {
            sortType: 'ascending',
        },
        providerId: {
            sortType: 'ascending',
        },
    };
    statusArray: any[] = [
        {
            id: '1',
            name: 'Approved'
        },
        {
            id: '0',
            name: 'Rejected'
        },
        {
            id: '2',
            name: 'Partially Approved'
        },
        {
            id: '3',
            name: 'Cancelled'
        }
    ];
    showAdvancedFilter: boolean = false;
    isInsideAdvacedContainer: boolean = false;
    advFilter: boolean = false;
    activeTab = 1;
    DynamicTabs: CommonList[] = []

    @ViewChild('advancedFilter') advancedFilter!: ElementRef
    constructor(
        private prescriptionService: PrescriptionService,
        private toasterandLoader: ToasterService,
        private userService: UserService,
        private utility: UtilityService,
        private router: Router,
    ) {
        this.user = userService.getUserInfo()?.userDetails;
        this.prescriptionFilterForm = new FormGroup({
            requestId: new FormControl(null),
            senderId: new FormControl(null),
            receiverId: new FormControl(null),
            payerId: new FormControl(null),
            memberId: new FormControl(null),
            documentID: new FormControl(null),
            status: new FormControl(null),
            healthId: new FormControl(null),
            prescriptionId: new FormControl(null),
            providerId: new FormControl(null),
            isOverriden: new FormControl(null),

        }, CustomValidation.formNotNull);
    }

    ngOnInit(): void {
        if(this.subTypeEvm !== this.subTypes.payer && this.checkPermission('getGeneralSettingsDynamicTab')){
            this.getAllTabs();
        }
        if (this.checkPermission('getAllTransaction') || this.checkPermission('getPayerTransaction') || this.checkPermission('getProviderTransaction')) {
            this.activeTab = 1;
        } 
        // else if (this.checkPermission('getAllLabTransaction')) {
        //     this.activeTab = 2;
        // } else {
        //     this.activeTab = 3;
        // }
        if (this.prescriptionService.activeTab > 0) {
            this.activeTab = this.prescriptionService.activeTab
        }
    }

    @HostListener('document:click', ['$event'])
    clickOutSideAdvancedContainer(event: any) {
        if (!this.isInsideAdvacedContainer && !this.advancedFilter?.nativeElement.contains(event.target as Node)) {
            this.showAdvancedFilter = false;
        }
        this.isInsideAdvacedContainer = false;
    }

    public getTransactionListByPayer(filterPayload: any) {
        this.prescriptionService.getTransactionListByPayer(filterPayload, <number>this.user?.payerId).subscribe(list => {
            this.transactionListByClient = list.data.data;
            if (!this.transactionListByClient.length) this.showNavigation = true;
            this.totalCount = list?.data?.total;
            this.toasterandLoader.isLoaderEnable(false);
        }, err => {
            this.toasterandLoader.isLoaderEnable(false);
        });
    }

    public getTransactionListByClient(filterPayload: any) {
        this.toasterandLoader.isLoaderEnable(true);
        this.prescriptionService.getTransactionList(filterPayload, 1).subscribe(list => {
            this.transactionListByClient = list.data.data;
            this.totalCount = list?.data?.total;
            if (!this.transactionListByClient.length) this.showNavigation = true;
            this.toasterandLoader.isLoaderEnable(false);
        }, err => {
            this.toasterandLoader.isLoaderEnable(false);
        });
    }

    private prescriptionCommonApi(filterPayload: any){
        this.toasterandLoader.isLoaderEnable(true);
        this.prescriptionService.getTransactionListCommon(filterPayload, 1).subscribe(list => {
            this.transactionListByClient = list.data.data;
            this.totalCount = list?.data?.total;
            if (!this.transactionListByClient.length) this.showNavigation = true;
            this.toasterandLoader.isLoaderEnable(false);
        }, err => {
            this.toasterandLoader.isLoaderEnable(false);
        });
    }

    public getTransactionListByProvider(filterPayload: any) {
        this.toasterandLoader.isLoaderEnable(true);
        this.prescriptionService.getTransactionListByProvider(filterPayload, <number>this.user?.providerId).subscribe(list => {
            this.transactionListByClient = list.data.data;
            if (!this.transactionListByClient.length) this.showNavigation = true;
            this.totalCount = list?.data?.total;
            this.toasterandLoader.isLoaderEnable(false);
        }, err => {
            this.toasterandLoader.isLoaderEnable(false);
        });
    }
    resetFilter() {
        this.prescriptionFilterForm.reset();
        this.page_limit = 10;
        this.page_no = 1;
        this.totalCount = 1;
        this.showNavigation = false;
        this.showAdvancedFilter = false;
        this.isInsideAdvacedContainer = false;
        this.userTypeListing();
    }
    showPrescriptionDetailsPopup(item: any) {
        this.showPrescriptionDetails = true;
        this.exportVar = 0;
        this.batchId = item?.requestId;
        this.requestBatchId = item?.requestBatchId;
    }
    isScrollIntoViewNeeded() {
        setTimeout(() => {
            this.focusedElement.last?.nativeElement.scrollIntoView();
        }, 100);
    }
    currentPageDetail(event: any) {
        if (event) {
            this.page_no = event.button_no;
            this.page_limit = event.item_per_page;
        }
        this.isScrollIntoViewNeeded();
        this.userTypeListing();
    }
    public userTypeListing() {
        let filterPayload = {
            per_page: this.page_limit,
            page: this.page_no,
            sort: this.sortParams,
            requestId: this.prescriptionFilterForm?.value?.requestId || '',
            senderId: this.prescriptionFilterForm?.value?.senderId || '',
            receiverId: this.prescriptionFilterForm?.value?.receiverId || '',
            payerId: this.prescriptionFilterForm?.value?.payerId || '',
            memberId: this.prescriptionFilterForm?.value?.memberId || '',
            facilityId: this.prescriptionFilterForm?.value?.documentID || '',
            healthId: this.prescriptionFilterForm?.value?.healthId || '',
            prescriptionId: this.prescriptionFilterForm?.value?.prescriptionId || '',
            providerId: this.prescriptionFilterForm?.value?.providerId || '',
            approvalStatus: this.prescriptionFilterForm?.value?.status || '',
            isOverriden: this.prescriptionFilterForm?.value?.isOverriden ? '1' : '',
        }
        this.prescriptionCommonApi(filterPayload);
        // if (this.user?.userType === USER_TYPE.payer && this.checkPermission('getPayerTransaction')) {
        //     this.getTransactionListByPayer(filterPayload);
        // } else if (this.user?.userType === USER_TYPE.provider && this.checkPermission('getProviderTransaction')) {
        //     this.getTransactionListByProvider(filterPayload);
        // } else if (this.user?.userType === USER_TYPE.system && this.checkPermission('getAllTransaction')) {
        //     this.getTransactionListByClient(filterPayload);
        // }
        this.showAdvancedFilter = false;
        this.isInsideAdvacedContainer = false;
    }
    sortColumn(colName: string) {

        for (const key in this.columnSort) {
            if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
                // const element = this.columnSort[key];
                if (key == colName) {
                    this.columnSort[colName].clicked = true;
                    this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
                    this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
                    this.page_no = 1;
                    this.userTypeListing();
                } else {
                    this.columnSort[key].sortType = 'ascending';
                }

            }
        }
    }
    selectedValue(event: any, formElem: string) {

        if (!event) {
            this.prescriptionFilterForm.controls[formElem].patchValue(null);
        }
        this.prescriptionFilterForm.controls[formElem].patchValue(event);
    }

    checkPermission(perName: string): boolean {
        return this.userService.getPermissions(perName);
    }
    onAdvancedClick(event: MouseEvent) {
        event?.stopPropagation();
        this.showAdvancedFilter = !this.showAdvancedFilter;
    }
    onInsideAdvanceContainerClick() {
        this.isInsideAdvacedContainer = true;
    }
    closeAdvanceFilter(controlName: string) {
        this.prescriptionFilterForm.controls[controlName].reset();
        this.isScrollIntoViewNeeded();
        this.userTypeListing();
    }
    switchTab(tab: number) {
        if (tab === 1 && this.activeTab !== 1) {
            // this.resetFilter();
            this.prescriptionFilterForm.reset();

        }
        this.exportVar = 0;
        this.prescriptionService.activeTab = this.activeTab = tab;
    }
    viewPop(event: any) {
        // this.showPrescriptionDetails = true;
        // this.exportVar = 0;
        // this.batchId = event?.batchId;
        // this.requestBatchId = event.requestBatchId;
        event.requestId = event.batchId
        this.navigateToView(event);
    }
    Export() {
        if (this.activeTab === 1) {
            let filterPayload = {
                sort: this.sortParams,
                requestId: this.prescriptionFilterForm?.value?.requestId || '',
                senderId: this.prescriptionFilterForm?.value?.senderId || '',
                receiverId: this.prescriptionFilterForm?.value?.receiverId || '',
                payerId: this.prescriptionFilterForm?.value?.payerId || '',
                memberId: this.prescriptionFilterForm?.value?.memberId || '',
                facilityId: this.prescriptionFilterForm?.value?.documentID || '',
                healthId: this.prescriptionFilterForm?.value?.healthId || '',
                prescriptionId: this.prescriptionFilterForm?.value?.prescriptionId || '',
                providerId: this.prescriptionFilterForm?.value?.providerId || '',
                approvalStatus: this.prescriptionFilterForm?.value?.status || '',
                iProviderType: null
            }
            this.prescriptionService.exportList(filterPayload)
                .pipe().subscribe({
                    next: (response: any) => {
                        this.utility.download(response, this.utility.downloadTypes.excel)
                        this.isLoader = false;
                    },
                    error: (error) => {
                        this.isLoader = false;
                        this.toasterandLoader.alert.toast({
                            title: 'Error',
                            type: 'error',
                            message: error.message
                        });
                    }
                });
        } else {
            this.exportVar++
        }
    }

    private getAllTabs() : void {
        this.toasterandLoader.isLoaderEnable(true);
        this.prescriptionService.getAllTabs({generatorType:'PRESCRIPTION'}).subscribe({
            next: (response: any) => {
                this.DynamicTabs = response.data
                this.toasterandLoader.isLoaderEnable(false);
                if(this.activeTab > this.DynamicTabs.length+1){
                    this.activeTab = 1;
                }
            },
            error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
                this.isLoader = false;
                this.toasterandLoader.alert.toast({
                    title: 'Error',
                    type: 'error',
                    message: error.message
                });
            }
        });
    }


    public navigateToView(item: TransactionListByClient): void {
        let url = this.router.url;
        if (url && item.requestId) {
            if (url.includes('/prescription/prescriptionlist')) {
                this.router.navigate(['prescription', 'detail-view', item.requestId]);
            }
        }
    }

}